  import React, { useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
  Box,
  Chip,
  Divider,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CommentIcon from "@mui/icons-material/Comment";
import CallIcon from "@mui/icons-material/Call";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import VillaIcon from '@mui/icons-material/Villa';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';


import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { AGENT_INCOMMING_CALL } from "../../../constants";

function MissedCallAgentTable({  filters, setFilters,setMissedFilters,missedFilters,
  setLoading,
  incomingMissed
}) {

    const calls = incomingMissed?.missedCalls || [];
      const totalRecords = incomingMissed?.pagination?.totalRecords || 0;
  const currentPage = incomingMissed?.pagination?.page || missedFilters.page;
  const pageSize = incomingMissed?.pagination?.pageSize || missedFilters.pageSize;


   // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setMissedFilters(prev => ({ ...prev, page: newPage + 1 })); // API expects 1-based
  };

  const handleChangeRowsPerPage = (event) => {
    setMissedFilters(prev => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      page: 1
    }));
  };

  
  function formatDateTimeCompact(isoString) {
  // Parse using Date constructor
  const date = new Date(isoString);
  
  if (isNaN(date)) return "-"; // fallback if invalid date

  // Get date parts
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = String(date.getUTCFullYear()).slice(-2); // last 2 digits

  // Get time parts
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // convert 0 to 12

  return `${day}-${month}-${year}, ${hours}:${minutes}${ampm}`;
}



  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded
  const [missedCallId, setMissedCallId] = useState(null); // Step 1
  

    // Filter states
    const [mobileFilter, setMobileFilter] = useState("");
    const [PreviousCallId, setPreviousCallId] = useState("");
    const [stateFilter, setStateFilter] = useState("");
    const [showFilters, setShowFilters] = useState(false);
    console.log("incomingMissed:::::::::::::::",incomingMissed)
    const { agentName, agentNo } = useParams();
  
    const [callData, setCallData] = useState([]);

      // State options for dropdown (you can modify this list as needed)
  const stateOptions = [
    "AP", "OD", "TN", "RJ", "GJ", "HR", "PN",
    "KT",
    "WB",
    "CG"
  ];

  //  const fetchConnectedData = () => {
  //     const { startDate, endDate } = filters;
  
  //     // Determine yesterday's date
  //     const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  
  //     // Format startDate and endDate, defaulting to yesterday if not provided
  //     const formattedStartDate = startDate
  //       ? dayjs(startDate).format("YYYY-MM-DD")
  //       : yesterday;
  //     const formattedEndDate = endDate
  //       ? dayjs(endDate).format("YYYY-MM-DD")
  //       : yesterday;
  
  //     // Build query params
  //     const queryParams = new URLSearchParams();
  //     queryParams.append("startDate", formattedStartDate);
  //     queryParams.append("endDate", formattedEndDate);
  
  //     if (localStorage.getItem("empRole") === "1") {
  //       queryParams.append("agentNumber", empDetails?.EmployeePhone);
  //     }
  //     queryParams.append("callStatus", "Missed");
  //     queryParams.append("page", page + 1); // Current page (1-based index)
  //     queryParams.append("pageSize", rowsPerPage); // Number of rows per page
  
  //     // // Add filter parameters
  //     // if (mobileFilter.trim()) {
  //     //   queryParams.append("bPartyNo", mobileFilter.trim());
  //     // }
  //     // if (stateFilter) {
  //     //   queryParams.append("state", stateFilter);
  //     // }
  
  //     setLoading(true);
  //     axios
  //       .get(`${AGENT_INCOMMING_CALL}?${queryParams.toString()}`)
  //       .then((response) => {
  //         const { calls, pagination, summary } = response.data;
  //         setMetricData(summary);
  //         setCallData(calls); // Update the call data
  //         setTotalCount(pagination.totalRecords); // Update the total record count
  //         setRowsPerPage(pagination.pageSize); // Update rows per page
  //         // Reset page if current page is out of range after filtering
  //         if ((page * rowsPerPage) >= pagination.totalRecords && page !== 0) {
  //           setPage(0);
  //         }
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching missed call data:", error);
  //         setCallData([]); // Set call data to empty on error
  //         setLoading(false);
  //       });
  //   };

      // useEffect(() => {
      //   fetchConnectedData();
      // }, []);
      // }, [filters, page, rowsPerPage, mobileFilter, stateFilter]);

//       useEffect(() => {
//   fetchConnectedData();
// }, [filters, page, rowsPerPage, mobileFilter, stateFilter, refetchToggle]);


// useEffect(() => {
//   if (!filters.startDate || !filters.endDate) return; // validate filters
//   fetchConnectedData();
// }, [filters, page, rowsPerPage, refetchToggle]);


        // Handle page change
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // // Handle rows per page change
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0); // Reset to the first page
  // };

    // Handle row expansion toggle
  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

    // Handle filter clear
  const handleClearFilters = () => {
    setMobileFilter("");
    setStateFilter("");
    setPage(0); // Reset to first page
  };

  // Handle mobile filter change
  const handleMobileFilterChange = (event) => {
    setMobileFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

    // Handle state filter change
    const handleStateFilterChange = (event) => {
      setStateFilter(event.target.value);
      setPage(0); // Reset to first page when filter changes
    };
  
    const formatDate = (dateString) =>
      moment(dateString).format("DD-MM-YYYY HH:mm:ss");

    
  const IconCell = ({ row }) => (
    <Button
      variant="contained"
      size="small"
      startIcon={<CallIcon />}
      onClick={() => handleCallIconClick(row)}
      color="error"
      sx={{
        minWidth: 'auto',
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'none',
        boxShadow: 1,
        '&:hover': {
          boxShadow: 2,
          transform: 'translateY(-1px)',
        },
        transition: 'all 0.2s ease',
      }}
    >
      Call Back
    </Button>
  );

  const handleCallIconClick = (row) => {
  console.log(row, "checking id");

  // customer number (b-party)
  const mobNo =
    row?.leadDetail?.MobileNo ||
    row?.bPartyNo ||
    "";

  // caller / agent number (a-party)
  const callerNumber =
    row?.aPartyNo ||
    row?.agent?.EmployeePhone ||
    empDetails?.EmployeePhone ||
    "";

  const missedCallId = String(row?.callId || "");

  setMissedCallId(missedCallId); // update state
  localStorage.setItem("missedCallId", missedCallId); // store in localStorage

  navigate("/dashboard", {
    state: {
      mobNo,
      lotNum: callerNumber,
      missedCallId,
    },
  });
};


  const InfoItem = ({ icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: 140,
        color: 'text.secondary',
        fontSize: '0.875rem',
        fontWeight: 500
      }}>
        {icon}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
        {value || "-"}
      </Typography>
    </Box>
    
  );

  return (
    <>
     <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {/* Filter Section */}
        <Box sx={{ p: 2, backgroundColor: 'error.50', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: showFilters ? 2 : 0 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}>
              <PhoneMissedIcon sx={{ mr: 1, color: 'error.main' }} />
              Missed Calls
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              color="error"
              sx={{ textTransform: 'none' }}
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button> */}
          </Box>

          {/* <Collapse in={showFilters}> */}
            {/* <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <TextField
                label="Mobile Number"
                value={mobileFilter}
                onChange={handleMobileFilterChange}
                placeholder="Enter mobile number"
                size="small"
                InputProps={{
                  startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />,
                }}
                sx={{ minWidth: 200 }}
              />

              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={stateFilter}
                  onChange={handleStateFilterChange}
                  label="State"
                >
                  <MenuItem value="">
                    <em>All States</em>
                  </MenuItem>
                  {stateOptions.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(mobileFilter || stateFilter) && (
                <Button
                  variant="outlined"
                  startIcon={<ClearIcon />}
                  onClick={handleClearFilters}
                  size="small"
                  color="error"
                  sx={{ textTransform: 'none' }}
                >
                  Clear Filters
                </Button>
              )}
            </Box> */}

            {/* Active filters display */}
            {/* {(mobileFilter || stateFilter) && (
              <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary', mr: 1 }}>
                  Active Filters:
                </Typography>
                {mobileFilter && (
                  <Chip
                    label={`Mobile: ${mobileFilter}`}
                    size="small"
                    color="error"
                    variant="outlined"
                    onDelete={() => setMobileFilter("")}
                  />
                )}
                {stateFilter && (
                  <Chip
                    label={`State: ${stateFilter}`}
                    size="small"
                    color="error"
                    variant="outlined"
                    onDelete={() => setStateFilter("")}
                  />
                )}
              </Box>
            )} */}
          {/* </Collapse> */}
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="missed calls table"
          >
            <TableHead>
              <TableRow sx={{
                backgroundColor: "error.main",
                '& .MuiTableCell-head': {
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                }
              }}>
                <TableCell width={60} sx={{ textAlign: "center" }} />
                {/* <TableCell
                  width={60}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  S.No
                </TableCell> */}
                 {/* <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PhoneIcon sx={{ mr: 1, fontSize: 18 }} />
                    Call Type
                  </Box>
                </TableCell> */}
                <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Customer Name
                  </Box>
                </TableCell>

                 <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <PhoneIcon sx={{ mr: 1, fontSize: 18 }} />
                    Mobile Number
                  </Box>
                </TableCell>

                <TableCell
                  width={150}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <VillaIcon sx={{ mr: 1, fontSize: 18 }} />
                    Region Name
                  </Box>
                </TableCell>
                <TableCell
                  width={160}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Time
                  </Box>
                </TableCell>
                {/* <TableCell
                  width={160}
                  sx={{ textAlign: "center", padding: 2 }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <MoreHorizIcon sx={{ mr: 1, fontSize: 18 }} />
                    Sub-Category
                  </Box>
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    width: "100px",
                    position: "sticky",
                    right: 0,
                    backgroundColor: "error.main",
                    zIndex: 100,
                    boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                    padding: 2,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <CallIcon sx={{ mr: 1, fontSize: 18 }} />
                    Action
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
<TableBody>
  {Array.isArray(calls) && calls.length > 0 ? (
    calls.map((row, rowIndex) => (
      <React.Fragment key={row.id || rowIndex}>
        {/* Main Row */}
        <TableRow
          sx={{
            "&:hover": { backgroundColor: "action.hover" },
            backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
            transition: "background-color 0.2s ease",
          }}
        >
          {/* Expand button */}
          <TableCell sx={{ padding: 1 }}>
            <IconButton
              onClick={() => handleRowToggle(rowIndex)}
              sx={{
                padding: 1,
                transition: "transform 0.2s ease",
                "&:hover": {
                  backgroundColor: "error.main",
                  color: "white",
                  transform: "scale(1.1)",
                },
              }}
            >
              {openRows.includes(rowIndex) ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          </TableCell>  

          {/* Serial Number */}
          {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
            <Chip
              // label={page * rowsPerPage + rowIndex + 1}
              label={(currentPage - 1) * pageSize + rowIndex + 1}
              size="small"
              variant="outlined"
              color="error"
            />
          </TableCell> */}

          {/* Call Type */}
          {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
            {row.leadDetail?.call_type || "-"}
          </TableCell> */}

          {/* Customer Name */}
          <TableCell
            sx={{ textAlign: "center", padding: 2 }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              {row.leadDetail?.CustomerName?.trim() || (
                <PhoneMissedIcon
                  sx={{ mr: 1, color: "error.main", fontSize: 18 }}
                />
              )}
            </Box>
          </TableCell>

          {/* Customer Number (bPartyNo) */}
          <TableCell
            sx={{ textAlign: "center", padding: 2, fontSize: "0.875rem" }}
          >
            {row.leadDetail?.MobileNo || row.caller_number || "-"}
          </TableCell>

          {/* Region */}
          <TableCell
            sx={{ textAlign: "center", padding: 2, fontSize: "0.875rem" }}
          >
            {row.leadDetail?.region_name || "-"}
          </TableCell>
          <TableCell
            sx={{ textAlign: "center", padding: 2, fontSize: "0.875rem" }}
          >
            {formatDateTimeCompact(row.call_start_time) || "-"}
          </TableCell>

          {/* Sticky Action Column */}
          <TableCell
            align="center"
            sx={{
              width: "100px",
              padding: 2,
              position: "sticky",
              right: 0,
              backgroundColor: rowIndex % 2 === 0 ? "grey.50" : "white",
              zIndex: 10,
              boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
              transition: "background-color 0.2s ease",
            }}
          >
            {localStorage.getItem("empRole") === "1" && <IconCell row={row} />}
          </TableCell>
        </TableRow>
{/* Expanded Row */}
<TableRow>
  <TableCell colSpan={5} sx={{ p: 0, bgcolor: "grey.50" }}>
<Collapse in={openRows.includes(rowIndex)} timeout="auto" unmountOnExit>
  <Box sx={{ p: 2 }}>
    {/* Customer Details Header */}
    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
      Customer Details
    </Typography>

    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Name
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {row.leadDetail?.CustomerName || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Phone
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {row.leadDetail?.MobileNo || row.caller_number || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Region
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {row.leadDetail?.region_name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          State
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {row.leadDetail?.state_name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Typography variant="body2" color="text.secondary">
          Postal Code
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {row.leadDetail?.pincode || "-"}
        </Typography>
      </Grid>

      {/* Remarks Section */}
      <Grid item xs={12}>
        <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600, mb: 2 }}>
          Remarks
        </Typography>

        {row.leadDetail?.agent_remark ? (
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.300",
              backgroundColor: "grey.50",
            }}
          >
            <Typography
              variant="body1"
              fontWeight={400}
              sx={{ whiteSpace: "pre-line" }}
            >
              {row.leadDetail.agent_remark}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              p: 3,
              textAlign: "center",
              borderRadius: 2,
              border: "1px dashed",
              borderColor: "grey.300",
              backgroundColor: "grey.50",
              color: "text.secondary",
            }}
          >
            <CommentIcon sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
            <Typography variant="body1">No remarks available</Typography>
          </Box>
        )}
      </Grid>
    </Grid>
  </Box>
</Collapse>

  </TableCell>
</TableRow>


      </React.Fragment>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            paddingLeft:"100px",
            alignItems: "center",
            color: "text.secondary",
          }}
        >
          <PhoneMissedIcon
            sx={{ fontSize: 64, mb: 2, opacity: 0.3, color: "error.main" }}
          />
          <Typography variant="h6" sx={{ mb: 1 }}>
            No Missed Calls
          </Typography>
          <Typography variant="body2">
            There are no missed calls to display for the selected period.
          </Typography>
          {(mobileFilter || stateFilter) && (
            <Typography
              variant="body2"
              sx={{ mt: 1, fontStyle: "italic" }}
            >
              Try adjusting your filters to see more results.
            </Typography>
          )}
        </Box>
      </TableCell>
    </TableRow>
  )}
</TableBody>

          </Table>
        </TableContainer>
        <TablePagination
        component="div"
        count={totalRecords}            // total unique calls
        page={currentPage - 1}          // convert to 0-based
        onPageChange={handleChangePage}
        rowsPerPage={pageSize}
        onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'grey.50'
          }}
        />
      </Paper>
    </>
  )
}

export default MissedCallAgentTable;